import { PrizmLanguageInputLayoutDateTimeRange } from '../../interfaces';

export const PRIZM_RUSSIAN_INPUT_LAYOUT_DATE_TIME_RANGE: PrizmLanguageInputLayoutDateTimeRange = {
  inputLayoutDateTimeRange: {
    time: 'Время',
  },
};
